import { apiRequestInitState } from "../constants";
import {
  FAILURE_GET_BACKEND_BUILD,
  REQUEST_GET_BACKEND_BUILD,
  SUCCESS_GET_BACKEND_BUILD,
} from "./actions";

export const backInfo =(state = apiRequestInitState, action) => {
  switch (action.type) {
    case REQUEST_GET_BACKEND_BUILD:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case SUCCESS_GET_BACKEND_BUILD:
      return {
        ...state,
        isFetching: false,
        payload: action.payload,
        error: null
      };
    case FAILURE_GET_BACKEND_BUILD:
      return {
        ...state,
        isFetching: false,
        payload: null,
        error: action.error
      };
    default:
      return state;
  }
}

